<template>
  <div class="trezo-card mb-[25px]">
    <div class="trezo-card-content">
      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-[25px]"
      >
        <div class="bg-white dark:bg-[#0c1427] p-[10px] rounded-md">
          <img
            src="@/assets/images/nfts/creator1.jpg"
            class="rounded-md"
            alt="creator-image"
          />
          <div class="text-center -mt-[34px]">
            <div class="relative mb-[15px] inline-block">
              <img
                src="@/assets/images/nfts/user.gif"
                class="rounded-full inline-block w-[68px]"
                alt="user-image"
              />
              <img
                src="@/assets/images/nfts/verified2.svg"
                class="absolute bottom-0 ltr:right-0 rtl:left-0"
                alt="verified"
              />
            </div>
            <h3 class="text-md font-semibold mb-[8px]">Hunny Bunny</h3>
            <span class="block text-xs"> ITEMS: 3204 </span>
            <div
              class="h-[1px] bg-primary-50 dark:bg-[#172036] my-[15px]"
            ></div>
            <button
              type="button"
              class="inline-block rounded-[7px] py-[6px] px-[17px] font-medium md:text-md bg-primary-500 text-white transition-all hover:bg-primary-400"
            >
              Follow
            </button>
          </div>
        </div>
        <div class="bg-white dark:bg-[#0c1427] p-[10px] rounded-md">
          <img
            src="@/assets/images/nfts/creator2.jpg"
            class="rounded-md"
            alt="creator-image"
          />
          <div class="text-center -mt-[34px]">
            <div class="relative mb-[15px] inline-block">
              <img
                src="@/assets/images/nfts/user.gif"
                class="rounded-full inline-block w-[68px]"
                alt="user-image"
              />
              <img
                src="@/assets/images/nfts/verified2.svg"
                class="absolute bottom-0 ltr:right-0 rtl:left-0"
                alt="verified"
              />
            </div>
            <h3 class="text-md font-semibold mb-[8px]">Aristocrat</h3>
            <span class="block text-xs"> ITEMS: 5301 </span>
            <div
              class="h-[1px] bg-primary-50 dark:bg-[#172036] my-[15px]"
            ></div>
            <button
              type="button"
              class="inline-block rounded-[7px] py-[6px] px-[17px] font-medium md:text-md bg-primary-500 text-white transition-all hover:bg-primary-400"
            >
              Follow
            </button>
          </div>
        </div>
        <div class="bg-white dark:bg-[#0c1427] p-[10px] rounded-md">
          <img
            src="@/assets/images/nfts/creator3.jpg"
            class="rounded-md"
            alt="creator-image"
          />
          <div class="text-center -mt-[34px]">
            <div class="relative mb-[15px] inline-block">
              <img
                src="@/assets/images/nfts/user.gif"
                class="rounded-full inline-block w-[68px]"
                alt="user-image"
              />
              <img
                src="@/assets/images/nfts/verified2.svg"
                class="absolute bottom-0 ltr:right-0 rtl:left-0"
                alt="verified"
              />
            </div>
            <h3 class="text-md font-semibold mb-[8px]">Hooman Robotic</h3>
            <span class="block text-xs"> ITEMS: 4213 </span>
            <div
              class="h-[1px] bg-primary-50 dark:bg-[#172036] my-[15px]"
            ></div>
            <button
              type="button"
              class="inline-block rounded-[7px] py-[6px] px-[17px] font-medium md:text-md bg-gray-400 text-white transition-all hover:bg-gray-400"
            >
              Unfollow
            </button>
          </div>
        </div>
        <div class="bg-white dark:bg-[#0c1427] p-[10px] rounded-md">
          <img
            src="@/assets/images/nfts/creator4.jpg"
            class="rounded-md"
            alt="creator-image"
          />
          <div class="text-center -mt-[34px]">
            <div class="relative mb-[15px] inline-block">
              <img
                src="@/assets/images/nfts/user.gif"
                class="rounded-full inline-block w-[68px]"
                alt="user-image"
              />
              <img
                src="@/assets/images/nfts/verified2.svg"
                class="absolute bottom-0 ltr:right-0 rtl:left-0"
                alt="verified"
              />
            </div>
            <h3 class="text-md font-semibold mb-[8px]">Colorful Life</h3>
            <span class="block text-xs"> ITEMS: 2314 </span>
            <div
              class="h-[1px] bg-primary-50 dark:bg-[#172036] my-[15px]"
            ></div>
            <button
              type="button"
              class="inline-block rounded-[7px] py-[6px] px-[17px] font-medium md:text-md bg-primary-500 text-white transition-all hover:bg-primary-400"
            >
              Follow
            </button>
          </div>
        </div>
        <div class="bg-white dark:bg-[#0c1427] p-[10px] rounded-md">
          <img
            src="@/assets/images/nfts/creator5.jpg"
            class="rounded-md"
            alt="creator-image"
          />
          <div class="text-center -mt-[34px]">
            <div class="relative mb-[15px] inline-block">
              <img
                src="@/assets/images/nfts/user.gif"
                class="rounded-full inline-block w-[68px]"
                alt="user-image"
              />
              <img
                src="@/assets/images/nfts/verified2.svg"
                class="absolute bottom-0 ltr:right-0 rtl:left-0"
                alt="verified"
              />
            </div>
            <h3 class="text-md font-semibold mb-[8px]">CryptoCanvas</h3>
            <span class="block text-xs"> ITEMS: 3204 </span>
            <div
              class="h-[1px] bg-primary-50 dark:bg-[#172036] my-[15px]"
            ></div>
            <button
              type="button"
              class="inline-block rounded-[7px] py-[6px] px-[17px] font-medium md:text-md bg-gray-400 text-white transition-all hover:bg-gray-400"
            >
              Unfollow
            </button>
          </div>
        </div>
        <div class="bg-white dark:bg-[#0c1427] p-[10px] rounded-md">
          <img
            src="@/assets/images/nfts/creator6.jpg"
            class="rounded-md"
            alt="creator-image"
          />
          <div class="text-center -mt-[34px]">
            <div class="relative mb-[15px] inline-block">
              <img
                src="@/assets/images/nfts/user.gif"
                class="rounded-full inline-block w-[68px]"
                alt="user-image"
              />
              <img
                src="@/assets/images/nfts/verified2.svg"
                class="absolute bottom-0 ltr:right-0 rtl:left-0"
                alt="verified"
              />
            </div>
            <h3 class="text-md font-semibold mb-[8px]">MetaVisionaries</h3>
            <span class="block text-xs"> ITEMS: 5301 </span>
            <div
              class="h-[1px] bg-primary-50 dark:bg-[#172036] my-[15px]"
            ></div>
            <button
              type="button"
              class="inline-block rounded-[7px] py-[6px] px-[17px] font-medium md:text-md bg-primary-500 text-white transition-all hover:bg-primary-400"
            >
              Follow
            </button>
          </div>
        </div>
        <div class="bg-white dark:bg-[#0c1427] p-[10px] rounded-md">
          <img
            src="@/assets/images/nfts/creator7.jpg"
            class="rounded-md"
            alt="creator-image"
          />
          <div class="text-center -mt-[34px]">
            <div class="relative mb-[15px] inline-block">
              <img
                src="@/assets/images/nfts/user.gif"
                class="rounded-full inline-block w-[68px]"
                alt="user-image"
              />
              <img
                src="@/assets/images/nfts/verified2.svg"
                class="absolute bottom-0 ltr:right-0 rtl:left-0"
                alt="verified"
              />
            </div>
            <h3 class="text-md font-semibold mb-[8px]">CryptoCultures</h3>
            <span class="block text-xs"> ITEMS: 4213 </span>
            <div
              class="h-[1px] bg-primary-50 dark:bg-[#172036] my-[15px]"
            ></div>
            <button
              type="button"
              class="inline-block rounded-[7px] py-[6px] px-[17px] font-medium md:text-md bg-gray-400 text-white transition-all hover:bg-gray-400"
            >
              Unfollow
            </button>
          </div>
        </div>
        <div class="bg-white dark:bg-[#0c1427] p-[10px] rounded-md">
          <img
            src="@/assets/images/nfts/creator8.jpg"
            class="rounded-md"
            alt="creator-image"
          />
          <div class="text-center -mt-[34px]">
            <div class="relative mb-[15px] inline-block">
              <img
                src="@/assets/images/nfts/user.gif"
                class="rounded-full inline-block w-[68px]"
                alt="user-image"
              />
              <img
                src="@/assets/images/nfts/verified2.svg"
                class="absolute bottom-0 ltr:right-0 rtl:left-0"
                alt="verified"
              />
            </div>
            <h3 class="text-md font-semibold mb-[8px]">Digital Mystique</h3>
            <span class="block text-xs"> ITEMS: 2314 </span>
            <div
              class="h-[1px] bg-primary-50 dark:bg-[#172036] my-[15px]"
            ></div>
            <button
              type="button"
              class="inline-block rounded-[7px] py-[6px] px-[17px] font-medium md:text-md bg-primary-500 text-white transition-all hover:bg-primary-400"
            >
              Follow
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div class="trezo-card-content">
      <Pagination items="8" total="36" class="px-[0] md:pt-[0]" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Pagination from "@/components/Common/Pagination.vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Creators",
  components: {
    Pagination,
  },
});
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .md\:pt-\[0\] {
    padding-top: 0 !important;
  }
}
.pt-\[0\] {
  padding-top: 0 !important;
}
</style>
